import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { RevisionPercancesService } from "../revision.service";
import { MyErrorStateMatcher, RequireMatch } from "src/app/utils/requireMatch";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import * as dayjs from "dayjs";
import {
  NgxImageCompressFormat,
  NgxImageCompressService,
} from "ngx-image-compress";
import dataURItoBlob from "src/app/utils/dataURItoBlob";

@Component({
  selector: "app-form-revision",
  templateUrl: "./form.component.html",
})
export class RevisionPercancesForm implements OnInit {
  public form: FormGroup;
  public formCombustible: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  @Input("list") list: any[];
  @Input("listUnidades") listUnidades: any[];
  @Output() onsave = new EventEmitter<{
    mode: string;
    value: any;
    type: number;
  }>();

  filteredOptions: Observable<any[]>;
  filteredUnidadesOptions: Observable<any[]>;
  matcher = new MyErrorStateMatcher();
  matcherUnidades = new MyErrorStateMatcher();
  listUni: any[] = [];
  listRec: any[] = [];
  public fileList: File[] = [];
  public imagesList: any[] = [];
  isChoferAsignado: boolean;

  constructor(
    private fb: FormBuilder,
    public service: RevisionPercancesService,
    private imageCompress: NgxImageCompressService,
  ) {}

  public ngOnInit() {
    this.buildForm();
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;

    this.imagesList = [];
    this.fileList = [];
    this.form.reset();
    this.form.controls["Descripcion"].enable();
    this.form.controls["Unidad"].enable();
    this.form.controls["Chofer"].enable();
    this.form.controls["IdChoferEsperado"].patchValue("");
    this.form.controls["EsChoferAsignado"].patchValue(true);
    this.isChoferAsignado = true;
  }
  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;

    this.form.controls["Descripcion"].patchValue(row?.Descripcion);
    this.form.controls["ChoferEsperado"].patchValue(row?.Nombre);
    this.form.controls["UnidadDesc"].patchValue(row?.Unidad);
    this.form.controls["EsChoferAsignado"].patchValue(row?.EsChoferAsignado);
    this.isChoferAsignado = row?.EsChoferAsignado;
    this.loadImages(this.defaults.IdRevisionPercance);
  }
  loadImages(id: any) {
    this.service.getPhothos(id).subscribe(
      (resultData) => {
        this.imagesList = resultData;
      },
      (err) => {
        console.error("error", err.error.Message);
      },
    );
  }
  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    const dataForm = this.form.value;

    const data = {
      ...dataForm,
      IdUnidad: dataForm.Unidad.Id,
      IdChofer: dataForm.Chofer.Id,
      files: this.fileList,
    };
    if (data.EsChoferAsignado) {
      data.IdChofer = data.IdChoferEsperado;
    }

    this.onsave.emit({
      mode: this.mode,
      value: data,
      type: 1,
    });
  }

  public update() {
    const dataForm = this.form.value;
    const data = { ...dataForm, IdTrabajador: dataForm.Chofer.Id };
    this.onsave.emit({
      mode: this.mode,
      value: data,
      type: 1,
    });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  private buildForm() {
    this.form = this.fb.group({
      Descripcion: ["", [Validators.required]],
      Unidad: ["", [Validators.required]],
      UnidadDesc: [{ value: "", disabled: true }],
      Chofer: [""],
      IdChoferEsperado: [""],
      ChoferEsperado: [{ value: "", disabled: true }],
      EsChoferAsignado: [true],
    });
    this.isChoferAsignado = true;
    if (this.mode != "update") {
      this.filteredOptions = this.form.controls["Chofer"].valueChanges.pipe(
        startWith(""),
        map((value) => this._filter(value)),
      );

      this.filteredUnidadesOptions = this.form.controls[
        "Unidad"
      ].valueChanges.pipe(
        startWith(""),
        map((value) => this._filterUnidades(value)),
      );

      this.form.controls["Unidad"].valueChanges.subscribe((value) => {
        if (value == undefined || value == null) return;
        if (typeof value === "string") return;
        this.checkChoferRequerido(value.Id);
      });
    }
  }

  checkChoferRequerido(id: any) {
    const unidad = this.listUnidades.find((f) => f.Id == id);

    this.form.controls["IdChoferEsperado"].patchValue(unidad.IdChofer);
    this.form.controls["ChoferEsperado"].patchValue(unidad.Chofer);
    this.form.controls["Chofer"].patchValue("");
    this.form.controls["EsChoferAsignado"].patchValue(true);
  }
  displayWith(item?: any): string | undefined {
    return item ? item.Desc : undefined;
  }
  private _filter(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();

    return this.list.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue),
    );
  }

  displayWithUnidad(item?: any): string | undefined {
    return item ? item.Desc : undefined;
  }
  private _filterUnidades(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();

    return this.listUnidades.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue),
    );
  }
  public getFile() {
    this.imageCompress
      .uploadMultipleFiles()
      .then((arrayOfFiles: NgxImageCompressFormat[]) => {
        for (let index = 0; index < arrayOfFiles.length; index++) {
          const element = arrayOfFiles[index];
          this.imageCompress
            .compressFile(element.image, element.orientation, 50, 50) // 50% ratio, 50% quality
            .then((compressedImage) => {
              const blob = dataURItoBlob(compressedImage);
              this.imagesList.push(compressedImage);
              this.fileList.push(
                new File([blob], "Imagen" + new Date().getTime().toString(16)),
              );
            });
        }
      });
  }
  public removeImage(src) {
    const inx = this.imagesList.findIndex((f) => f == src);
    this.imagesList.splice(inx, 1);
    this.fileList.splice(inx, 1);
  }
}
